import { NODE_TYPES } from "utils/constants";

export const ICON_PATHS = {
  screen: "M3 5h18v12H3z M8 21h8 M12 17v4",
  form: "M9 3h6v3H9z M7 4.5H5V21h14V4.5h-2 M8.5 11h7 M8.5 15h5",
  wait: "M6 3h12 M6 21h12 M7.5 3v3.5L12 12l-4.5 5.5V21 M16.5 3v3.5L12 12l4.5 5.5V21",
  decision: "M12 3l9 9-9 9-9-9z",
  timer: "M9 2h6 M12 9v4l2.5 2 M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
  fork: "M6 3v5a5 5 0 0 0 5 5h1 M18 3v5a5 5 0 0 1-5 5h-1 M12 13v8",
  join: "M12 3v8 M12 11h-1a5 5 0 0 0-5 5v5 M12 11h1a5 5 0 0 1 5 5v5",
  bolt: "M13 2L4 14h7l-1 8 9-12h-7z",
  back: "M9 14L4 9l5-5 M4 9h11a5 5 0 0 1 0 10h-4",
  warn: "M12 3.5l9.5 16.5h-19z M12 10v4.5 M12 17.5v.01",
  info: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 11v5 M12 8v.01",
  play: "M7 4l13 8-13 8z",
  check: "M5 12l5 5 9-10",
  plus: "M12 5v14 M5 12h14",
  close: "M6 6l12 12 M18 6L6 18",
  chevronDown: "M6 9l6 6 6-6",
  chevronRight: "M9 6l6 6-6 6",
  dots: "M5 12h.01 M12 12h.01 M19 12h.01",
  grip: "M9 6h.01 M15 6h.01 M9 12h.01 M15 12h.01 M9 18h.01 M15 18h.01",
  pencil: "M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z",
  arrow: "M5 12h14 M13 6l6 6-6 6",
  arrowLeft: "M19 12H5 M11 6l-6 6 6 6",
  trash: "M4 7h16 M9 7V4h6v3 M6 7l1 13h10l1-13",
  search: "M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14z M20 20l-4-4",
  flag: "M5 21V4h11l-2 4 2 4H5",
  layout: "M4 4h6v6H4z M14 14h6v6h-6z M7 10v4a3 3 0 0 0 3 3h4",
  plug: "M9 2v6 M15 2v6 M6 8h12v4a6 6 0 0 1-12 0z M12 18v4",
  database:
    "M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3z M4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6 M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3",
  sync: "M4 12a8 8 0 0 1 14-5l2 2 M20 4v5h-5 M20 12a8 8 0 0 1-14 5l-2-2 M4 20v-5h5",
  clock: "M9 2h6 M12 9v4l2.5 2 M12 21a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
  journey:
    "M4 5a2 2 0 1 0 4 0 2 2 0 1 0-4 0 M16 12a2 2 0 1 0 4 0 2 2 0 1 0-4 0 M4 19a2 2 0 1 0 4 0 2 2 0 1 0-4 0 M6 7v10 M8 5h4a4 4 0 0 1 4 4v1 M8 19h4a4 4 0 0 0 4-4v-1",
  layers: "M12 3l9 5-9 5-9-5z M3 13l9 5 9-5",
  quote: "M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z",
};

const LOOKS = {
  screen: { tone: "screen", icon: ICON_PATHS.screen },
  form: { tone: "form", icon: ICON_PATHS.form },
  wait: { tone: "wait", icon: ICON_PATHS.wait },
  decision: { tone: "decision", icon: ICON_PATHS.decision },
  timer: { tone: "timer", icon: ICON_PATHS.timer },
  fork: { tone: "fork", icon: ICON_PATHS.fork },
  join: { tone: "join", icon: ICON_PATHS.join },
  action: { tone: "action", icon: ICON_PATHS.bolt },
};

const LOOK_BY_NODE_TYPE = {
  [NODE_TYPES.STATUS]: LOOKS.screen,
  [NODE_TYPES.FORM_STEP]: LOOKS.form,
  [NODE_TYPES.AWAIT_SIGNATURE]: LOOKS.wait,
  [NODE_TYPES.AWAIT_PAYMENT]: LOOKS.wait,
  [NODE_TYPES.AWAIT_MANAGEMENT_ACK]: LOOKS.wait,
  [NODE_TYPES.AWAIT_TERMINATION_ACK]: LOOKS.wait,
  [NODE_TYPES.DECISION]: LOOKS.decision,
  [NODE_TYPES.TIMER]: LOOKS.timer,
  [NODE_TYPES.FORK]: LOOKS.fork,
  [NODE_TYPES.JOIN]: LOOKS.join,
};

export const stepLook = (nodeType) =>
  LOOK_BY_NODE_TYPE[nodeType || NODE_TYPES.STATUS] || LOOKS.action;
